import revive_payload_client_4sVQNw7RlN from "H:/Project/vana_front/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "H:/Project/vana_front/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "H:/Project/vana_front/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "H:/Project/vana_front/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "H:/Project/vana_front/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "H:/Project/vana_front/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "H:/Project/vana_front/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "H:/Project/vana_front/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "H:/Project/vana_front/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "H:/Project/vana_front/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_WLsn00x1qh from "H:/Project/vana_front/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import jquery_client_gAOI07dzQh from "H:/Project/vana_front/plugins/jquery.client.ts";
import persian_datetime_picker_client_dWeA9hGq4B from "H:/Project/vana_front/plugins/persian-datetime-picker.client.ts";
import printThis_client_js_EPRKXSYdt1 from "H:/Project/vana_front/plugins/printThis.client.js.ts";
import vue_draggable_OKRqLUiGtd from "H:/Project/vana_front/plugins/vue-draggable.ts";
import vuetify_7h9QAQEssH from "H:/Project/vana_front/plugins/vuetify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_WLsn00x1qh,
  jquery_client_gAOI07dzQh,
  persian_datetime_picker_client_dWeA9hGq4B,
  printThis_client_js_EPRKXSYdt1,
  vue_draggable_OKRqLUiGtd,
  vuetify_7h9QAQEssH
]